import { cn } from '../../../lib/utils';

interface CaseStudyGridSkeletonProps {
  className?: string;
  showPagination?: boolean;
  itemsCount?: number;
}

export function DocumentHubSkeleton({
  className = '',
  // showPagination = false,
  itemsCount = 9,
}: CaseStudyGridSkeletonProps) {
  const getSkeletonCount = () => {
    // Layout aims for 1 col on mobile, 2 cols on md, 3 cols on xl
    // const mdCols = 2;
    const xlCols = 3;
    const minItems = xlCols * 2; // at least 2 rows on xl
    if (itemsCount <= minItems) return minItems;
    const completeRows = Math.ceil(itemsCount / xlCols);
    return Math.max(completeRows * xlCols, minItems);
  };

  const skeletonCount = getSkeletonCount();

  const DocumentHubItemSkeleton = () => (
    <div className="p-4 rounded-xl border border-platinum bg-white animate-pulse">
      <div className="flex justify-between gap-4">
        <div className="relative w-16 h-[90px] shrink-0 overflow-hidden rounded-md bg-neutral-200" />

        <div className="flex flex-col gap-8 flex-1 min-w-0 justify-between">
          <div className="h-4 w-3/4 bg-neutral-200 rounded" />

          <div className="flex items-center gap-8">
            <div className="h-4 w-16 bg-neutral-200 rounded" />
            <div className="h-4 w-20 bg-neutral-200 rounded" />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={cn('flex flex-col items-center gap-8 md:gap-20 self-stretch bg-white skeleton-container', className)}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-5 lg:gap-y-6 gap-4">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <DocumentHubItemSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
